import React from 'react';
import { Tooltip } from '@mui/material';

/**
 * 판매담당자 표시(#122). 서버는 "공수민 60% · 박진현 40%" 한 문장으로 준다.
 * 목록·결제내역 칸에서는 "공수민 외 1" 로 줄이고, 마우스를 올리면 비율까지 전부 보여준다(사용자 결정 2026-09-16).
 * 1명이면 이름 그대로.
 */
const SEPARATOR = ' · ';

export const splitSellers = managerName => {
  if (!managerName || typeof managerName !== 'string') return [];
  return managerName
    .split(SEPARATOR)
    .map(part => part.trim())
    .filter(Boolean);
};

export const compactSellerName = managerName => {
  const sellers = splitSellers(managerName);
  if (sellers.length < 2) return managerName || '';
  const firstName = sellers[0].replace(/\s+\d{1,3}%$/, '');
  return `${firstName} 외 ${sellers.length - 1}`;
};

const SellerNameCell = ({ managerName, fallback = '-', component: Component = 'span', ...rest }) => {
  const sellers = splitSellers(managerName);
  if (sellers.length < 2) return <Component {...rest}>{managerName || fallback}</Component>;
  return (
    <Tooltip title={managerName} arrow placement="top">
      <Component {...rest} style={{ cursor: 'default', ...(rest.style || {}) }}>
        {compactSellerName(managerName)}
      </Component>
    </Tooltip>
  );
};

export default SellerNameCell;
